import { post } from '.';

export function CreateTranslation(options = {}) {
	return post<any>("/app/api/translations", options);
}
